/**
 * @file
 * The individual markers used by BasstrakkMap component.
 */
import * as React from 'react';
import { Marker, Popup } from 'react-leaflet';

// Config
import { getAnglerById } from '../processing';

// Types
import { IPopupMarker } from '../types';

// Context
import { MarkerContext } from '../BasstrakkMap';

export class PopupMarker extends React.PureComponent<IPopupMarker> {
  public render() {
    const { anglerId, icon, position } = this.props;

    return (
      <MarkerContext.Consumer>
        {({ onMarkerClick, locationData }) => (
          <Marker
            icon={icon}
            position={position}
            onClick={() => onMarkerClick({ ...this.props })}
            data-testid="map-popup-marker"
          >
            <Popup>
              <span className="marker-popup">
                {getAnglerById(anglerId, locationData).anglerName}
              </span>
            </Popup>
          </Marker>
        )}
      </MarkerContext.Consumer>
    );
  }
}
